export function prepareImageUrl(url: string, size: number) {
  return `${url}&h=${size}`;
}
